import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import NumberInputComma from '../../component/dccore-form/numberInputComma.vue'
import datePicker from '../../component/dccore-form/datePicker.vue'
import moment from 'moment'

if ($('#offer_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#offer_form',
    components: {
      RingLoader,
      TextInput,
      NumberInput,
      Singleselect,
      datePicker,
      NumberInputComma
    },
    mixins: [mixins],
    data: {
      loading: 0,
      form: {
        entity: {
          product: null,
          unitPrice: null,
          active : true,
          productWeight: 0,
          date: moment().format('YYYY-MM-DD HH:mm'),
        },
        options: {
          statuses: [ { 'id' : true,
            'name' : 'Aktywny' }, { 'id' : false,
            'name' : 'Nieaktywny' },
          ],
          products: [],
          suppliers: [],
          errors: {}
        }
      },
      entityId: null,
    },
    watch : {
      'form.entity.product' : function () {
        this.getProductWeight()
      },
      'form.entity.unitPrice' : function () {
        this.calculateKgPrice()
      }
    },
    mounted: function () {
      this.loading++

      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getOffer()
      }

      this.getProducts()
      this.getSuppliers()

      let productId = $('#product_id').val()
      if (productId) {
        this.form.entity.product = productId
        this.form.entity.selectedProduct = productId
      }

      this.loading--
    },
    methods: {
      createOffer(redirect) {
        let url = Routing.generate('api_post_offer')

        let data = { data: this.form.entity }
        this.loading++

        this.$http.post(url, data).then(() => {
          if (redirect) {
            let productId = $('#product_id').val()

            // if product id is defined then go back to product
            if (productId) {
              $(location).attr('href', Routing.generate('product_show', { id: productId }))
            // and if not, then just do normal redirect
            } else {
              $(location).attr('href', Routing.generate('offer_grid'))
            }
          } else {
            toastr.success(Translator.trans('offer.create.created'))
            this.form.options.errors = {}
          }
          this.loading--

        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateOffer(redirect) {
        this.loading++

        let url = Routing.generate('api_patch_offer', {
          id: this.entityId,
        })

        let data = { data: this.form.entity }

        this.$http.patch(url, data).then(() => {
          if (redirect) {
            let productId = $('#product_id').val()

            // if product id is defined then go back to product
            if (productId) {
              $(location).attr('href', Routing.generate('product_show', { id: productId }))
            // and if not, then just do normal redirect
            } else {
              $(location).attr('href', Routing.generate('offer_grid'))
            }
          } else {
            toastr.success(Translator.trans('offer.update.updated'))
            this.form.options.errors = {}
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      getOffer() {
        this.loading++
        let url = Routing.generate('api_get_offer', { id: this.entityId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.form.entity = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getProducts() {
        this.loading++
        let url = Routing.generate('api_get_active_products', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.products = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getSuppliers() {
        this.loading++
        let url = Routing.generate('api_get_suppliers', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.suppliers = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getProductWeight() {

        if (!this.form.entity.product) {
          return
        }

        this.loading++
        let url = Routing.generate('api_get_product', { id: this.form.entity.product,
          context: 'weight' })

        this.$http.get(url).then(response => {
          this.form.entity.productWeight = response.data.weight
          this.calculateKgPrice()
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      calculateKgPrice() {
        if (this.form.entity.unitPrice === null) {
          return
        }

        let unitPrice = parseFloat(this.form.entity.unitPrice.replace(',', '.'))
        if (! (unitPrice >= 0 && this.form.entity.productWeight >= 0)) {
          return
        }

        this.form.entity.kgPrice = parseFloat(unitPrice / this.form.entity.productWeight).toFixed(2)
        this.$forceUpdate()
      }
    }
  })
}
